import { UseQueryResult, useQuery } from '@tanstack/react-query';

import SurveyRequestResponse from '../../../shared/models/survey/SurveyRequestResponse';
import { getSurvey } from '../data/SurveyService';

const useSurvey = (activationCode: string | null, language: string): UseQueryResult<SurveyRequestResponse, Error> =>
  useQuery(['survey', language], () => getSurvey(activationCode, language), {
    staleTime: undefined,
  });

export default useSurvey;
